<template>
  <v-row v-if="attributes.length">
    <v-col cols="12">
      <div class="title">
        Attributes
      </div>
    </v-col>
    <v-col
      v-if="!attributes.length"
      cols="12">
      No attributes found, Please select category first.
    </v-col>
    <template v-for="(attribute, index) in formData">
      <v-col
        v-if="!isHideInput(attribute.id)"
        :key="attribute.id"
        cols="12"
        md="4">
        <gw-combobox
          v-if="attribute.isCustomizable"
          v-model="formData[index].values"
          :label="attribute.name"
          :items="attribute.options"
          item-text="name"
          item-value="id"
          :multiple="attribute.isMultipleSelection"
          :chips="attribute.isMultipleSelection"
          :small-chips="attribute.isMultipleSelection"
          :deletable-chips="attribute.isMultipleSelection"
          outlined
          return-object
          hide-details
          :disabled="loading || disabled" />
        <v-autocomplete
          v-else
          v-model="formData[index].values"
          :label="attribute.name"
          :items="attribute.options"
          item-text="name"
          item-value="id"
          :multiple="attribute.isMultipleSelection"
          :chips="attribute.isMultipleSelection"
          :small-chips="attribute.isMultipleSelection"
          :deletable-chips="attribute.isMultipleSelection"
          outlined
          return-object
          hide-details
          :disabled="loading || disabled" />
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    attributes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formData: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    isHideInput (id) {
      return id === '100000' || id === '100007'
    }
  }
}
</script>
